//customize

// FOOTER

document.addEventListener("DOMContentLoaded", function () {
  const titles = document.querySelectorAll("[data-accordion]");

  titles.forEach(title => {
    title.addEventListener("click", function (e) {
      if (window.innerWidth >= 750) return;

      const list = this.nextElementSibling;
      if (list) {
        e.preventDefault();
        if (list.style.display === "block") {
          list.style.display = "none";
          this.classList.remove('is-open');
        } else {
          this.classList.add('is-open');
          list.style.display = "block";
        }
      }
    });
  });
});

// TAB SWITCHER
document.addEventListener("DOMContentLoaded", function () {
const tabs = document.querySelectorAll(".js-tab");

for (let i = 0; i < tabs.length; i++) {
  tabs[i].addEventListener("click", tabSwitch);
}
function tabSwitch() {
  const ancestorEle = this.closest(".aw-tab-switcher");
  const active_tab_classes = "current";
  const inactive_tab_classes = "hover:bg-gray-100";
  ancestorEle
    .getElementsByClassName(active_tab_classes)[0]
    .classList.add(inactive_tab_classes);
  ancestorEle
    .getElementsByClassName(active_tab_classes)[0]
    .classList.remove(active_tab_classes);
  this.classList.add(active_tab_classes);
  this.classList.remove(inactive_tab_classes);

  // コンテンツのclassの値を変更
  const active_content_classes = "block";
  const inactive_content_classes = "hidden";
  const targetEle = ancestorEle.getElementsByClassName(
    active_content_classes
  )[0];
  targetEle.classList.remove(active_content_classes);
  targetEle.classList.add(inactive_content_classes);

  const groupTabs = ancestorEle.getElementsByClassName("js-tab");
  const arrayTabs = Array.prototype.slice.call(groupTabs);
  const index = arrayTabs.indexOf(this);
  const targetPanel = ancestorEle.getElementsByClassName("js-panel")[index];
  targetPanel.classList.add(active_content_classes);
  targetPanel.classList.remove(inactive_content_classes);
}
});

// collection newarrival
document.addEventListener("DOMContentLoaded", () => {
  // 各セクション（.select-collections-slider クラス）を個別に処理
  const sections = document.querySelectorAll(".select-collections-slider");
  
  console.log(`見つかったセクション数: ${sections.length}`);
  
  sections.forEach((section, sectionIndex) => {
    // 各セクション内のタブとコンテンツのみを取得
    const tabs = section.querySelectorAll(".collection-tabs-slider__tab");
    const contents = section.querySelectorAll(".collection-tabs-slider__slider");
    
    console.log(`セクション${sectionIndex}: タブ数=${tabs.length}, コンテンツ数=${contents.length}`);
    
    tabs.forEach((btn, tabIndex) => {
      btn.addEventListener("click", () => {
        console.log(`セクション${sectionIndex}のタブ${tabIndex}がクリックされました`);
        
        // 同じセクション内のタブとコンテンツのみを対象に処理
        tabs.forEach(b => b.classList.remove("active"));
        contents.forEach(c => c.classList.remove("active"));
        
        btn.classList.add("active");
        
        // 同じセクション内のターゲットコンテンツを探す
        const targetId = btn.dataset.tab;
        const targetContent = section.querySelector(`#${targetId}`);
        
        console.log(`ターゲットID: ${targetId}, 見つかった要素:`, targetContent);
        
        if (targetContent) {
          targetContent.classList.add("active");
          console.log(`コンテンツにactiveクラスを追加しました`);
        } else {
          console.log(`ターゲットコンテンツが見つかりませんでした`);
        }
      });
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  $(".collection-tabs-slider__products").each(function () {
    const $slider = $(this);

    if (!$slider.hasClass("slick-initialized")) {
      $slider.slick({
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        speed: 300,
        responsive: [
          {
            breakpoint: 749,
            settings: {
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  function initInfoSlider(scope = document) {
    $(scope).find(".aw-info .blog-listing").each(function () {
      const $slider = $(this);
      if (window.innerWidth <= 750) {
        if (!$slider.hasClass("slick-initialized")) {
          $slider.slick({
            dots: false,
            arrows: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: false,
            speed: 300
          });
        }
      } else {
        if ($slider.hasClass("slick-initialized")) {
          $slider.slick("unslick");
        }
      }
    });
  }
  initInfoSlider();

  window.addEventListener("resize", function () {
    initInfoSlider();
  });

  // sectionの追加と削除後の処理
  document.addEventListener("shopify:section:load", function (event) {
    initInfoSlider(event.target);
  });
  document.addEventListener("shopify:section:unload", function (event) {
    $(event.target).find(".aw-info .blog-listing.slick-initialized").slick("unslick");
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll('.menu__item.parent');

  buttons.forEach(button => {
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.attributeName === 'class') {
          const target = mutation.target;
          const headerWrapper = target.closest('.header__wrapper');
          if (!headerWrapper) return;

          if (target.classList.contains('is-visible')) {
            headerWrapper.classList.add('meganav--visible');
          } else {
            headerWrapper.classList.remove('meganav--visible');
          }
        }
      });
    });

    observer.observe(button, { attributes: true });
  });
});

// product 
document.addEventListener('DOMContentLoaded', () => {
  const captionEl = document.getElementById('ActiveMediaCaption');
  const counterEl = document.getElementById('ActiveMediaCounter');
  if (!captionEl && !counterEl) return;

  function updateCaptionAndCounter() {
    // 今表示中のスライド
    const activeSlide = document.querySelector('.product__slide.media--active img');
    const slides = document.querySelectorAll('.product__slide img');

    if (captionEl) {
      const text = activeSlide?.getAttribute('alt')?.trim() || '';
      captionEl.textContent = text;
      captionEl.style.display = text ? '' : 'none';
    }
    // --- 番号の更新 ---
    if (counterEl && activeSlide && slides.length > 0) {
      const currentIndex = Array.from(slides).indexOf(activeSlide);
      counterEl.textContent = `${currentIndex + 1} / ${slides.length}`;
    }
  }


  // 初期表示
  updateCaptionAndCounter();

  // スライド切り替え時に監視
  const gallery = document.querySelector('product-images');
  if (gallery) {
    new MutationObserver(updateCaptionAndCounter).observe(gallery, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  }
});

// 商品詳細画像が1枚の場合の崩れ対策
document.addEventListener('DOMContentLoaded', () => {
  const productImage = document.querySelector('.media--active');
  const acc = document.querySelector('.product-media__caption_area');
  let cap_position = productImage.offsetHeight + 20;
  let acc_position = productImage.offsetHeight - 92;
  const element = document.querySelector('.product-single__photos');
  if (window.innerWidth >= 750) {
    if (element.dataset.total === '1'){
      acc.style.top = `${cap_position}px`;
      document.body.style.setProperty('--acc-position', `${acc_position}px`);
    }
  }
});

